"use client";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";

import ContactForm from "../ContactForm";
import { ReactNode } from "react";

export default function ContactDialog({ children }: { children: ReactNode }) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Contact Us</DialogTitle>
        </DialogHeader>
        <ContactForm byline="Send us a message directly to our Telegram channel and we'll get back to you rapidly with gusto!" />
      </DialogContent>
    </Dialog>
  );
}
